import React, { ReactElement } from 'react';
import { Field } from 'react-final-form';
import { I18n, Translate } from 'react-redux-i18n';
import image from '../../../../../img/structure-pro/addresse-postale.svg';
import TextInput from '../../../../common/inputs/TextInput';
import { validateZipCode } from '../../../../../services/utils';

type Props = {
  getDisplayedError: (fieldName: string) => string,
  readonly: boolean,
};

function StructureAddressPostal(props: Props): ReactElement {
  return (
    <div className="structure-container structure-contact">
      <div className="structure-illustration-container">
        <div className="container-img structure-illustration">
          <img
            className="structure-illustration"
            src={image}
            alt="ILLUSTRATION"
          />
        </div>
      </div>
      <div className="structure-drawer-title-container">
        <div className="structure-drawer-title">
          <Translate value="STRUCTURE_INFORMATION.STRUCTURE_POSTAL_ADDRESS" />
        </div>
        <div className="structure-address-form">
          <Field
            name="ctmAdrPostal3"
            component={TextInput}
            placeholder={I18n.t('STRUCTURE_INFORMATION.BATIMENT')}
            type="text"
            customError={props.getDisplayedError('ctmAdrPostal3')}
            readOnly={props.readonly}
          />
          <Field
            name="ctmAdrPostal4"
            component={TextInput}
            placeholder={I18n.t('STRUCTURE_INFORMATION.ADRESSE')}
            type="text"
            customError={props.getDisplayedError('ctmAdrPostal4')}
            readOnly={props.readonly}
          />
          <Field
            name="ctmAdrPostal5"
            component={TextInput}
            placeholder={I18n.t('STRUCTURE_INFORMATION.COMPLEMENT')}
            type="text"
            customError={props.getDisplayedError('ctmAdrPostal5')}
            readOnly={props.readonly}
          />
          <Field
            name="ctmAdrPostalCodePostal"
            component={TextInput}
            placeholder={I18n.t('STRUCTURE_INFORMATION.CODE_POSTAL')}
            type="text"
            customError={props.getDisplayedError('ctmAdrPostalCodePostal')}
            readOnly={props.readonly}
            validate={validateZipCode}
          />
          <Field
            name="ctmAdrPostalVille"
            component={TextInput}
            placeholder={I18n.t('STRUCTURE_INFORMATION.VILLE')}
            type="text"
            customError={props.getDisplayedError('ctmAdrPostalVille')}
            readOnly={props.readonly}
          />
        </div>
      </div>
    </div>
  );
}
export default StructureAddressPostal;
